import React from 'react';
import { Table, Switch } from 'antd';
import { useTranslation } from 'react-i18next';
import { dateFormat } from '@utils/formatters';
import CustomTag from '@components/CustomTag';
import CustomCard from '@components/CustomCard';
import { HistoricProps } from '.';

const HistoricCard = ({ data }: { data: HistoricProps }) => {
  const { t } = useTranslation('alerts');

  const tableData = [
    {
      alert100: data?.alert100,
      alert90: data?.alert90,
      alert80: data?.alert80,
      alert70: data?.alert70,
      alert60: data?.alert60,
    },
  ];

  return (
    <CustomCard
      title={
        <CustomTag color={data?.operation === 'CREATED' ? 'green' : 'blue'}>
          {data?.operation === 'CREATED'
            ? t('consumption.created')
            : t('consumption.updated')}
        </CustomTag>
      }
      extra={
        <div style={{ textAlign: 'end' }}>
          <p style={{ margin: 0, fontSize: '0.8rem' }}>{data?.createdBy}</p>
          <p style={{ margin: 0, fontSize: '0.8rem', fontWeight: 'bold' }}>
            {dateFormat(data?.createdAt)}
          </p>
        </div>
      }
      style={{ width: '100%' }}
    >
      <Table
        size="small"
        dataSource={tableData}
        columns={[100, 90, 80, 70, 60].map(value => ({
          title: `${value}%`,
          align: 'center' as const,
          dataIndex: `alert${value}`,
          render: alert => <Switch size="small" checked={alert} />,
        }))}
        pagination={false}
      />
      {data?.notificationEmails?.map(email => (
        <CustomTag key={email} style={{ margin: 8 }}>
          {email}
        </CustomTag>
      ))}
    </CustomCard>
  );
};

export default HistoricCard;
